import { useState } from 'react';

export default function HeroSection() {
  const [copied, setCopied] = useState(false);
  const serverIP = 'play.furukomc.tr:25633';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(serverIP);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/22c9fb7ddb4f5e0f3b5775c083a9b0e5.jpg"
          alt="Minecraft Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-purple-900/60 via-black/50 to-[#1a0b2e]/90"></div>
      </div>

      {/* Animated Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-cyan-400/30 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/c4da685b094ca03001fa4ce318bf4660/f59786c2d124de0541605a3b17561e77.png"
            alt="FurukoNetwork Logo"
            className="w-32 h-32 rounded-full ring-4 ring-cyan-400/50 shadow-2xl shadow-cyan-500/50"
          />
        </div>

        <h1 className="text-7xl md:text-8xl font-black text-white mb-4 tracking-tight" style={{ textShadow: '0 0 40px rgba(0, 240, 255, 0.5)' }}>
          FurukoNetwork
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-4 font-light">
          Premium Minecraft Deneyimi
        </p>
        <p className="text-lg text-gray-400 mb-12 font-light">
          En iyi survival macerasında binlerce oyuncuya katıl
        </p>

        {/* Server IP Box */}
        <div className="inline-flex items-center gap-3 bg-black/60 backdrop-blur-md px-8 py-4 rounded-full border border-cyan-400/30 mb-8 hover:border-cyan-400/60 transition-all">
          <span className="text-cyan-400 font-mono text-xl md:text-2xl font-semibold">{serverIP}</span>
          <button
            onClick={copyToClipboard}
            className="w-10 h-10 flex items-center justify-center hover:bg-cyan-400/20 rounded-full transition-all cursor-pointer"
          >
            <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} text-xl text-cyan-400`}></i>
          </button>
        </div>

        {copied && (
          <div className="mb-4 text-lime-400 font-semibold animate-pulse">
            IP Panoya Kopyalandı!
          </div>
        )}

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://discord.gg/FurukoNetwork"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-[#5865F2] hover:bg-[#4752C4] text-white rounded-full font-bold text-lg transition-all hover:scale-105 hover:shadow-2xl hover:shadow-[#5865F2]/50 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-discord-fill text-2xl"></i>
            Discord'a Katıl
          </a>
          <button
            onClick={() => {
              const element = document.getElementById('shop');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-gradient-to-r from-lime-400 to-cyan-400 hover:from-lime-500 hover:to-cyan-500 text-black rounded-full font-bold text-lg transition-all hover:scale-105 hover:shadow-2xl hover:shadow-lime-400/50 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-2-fill text-2xl"></i>
            Mağazayı Ziyaret Et
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-cyan-400"></i>
      </div>
    </section>
  );
}
